import accounting from 'accounting';

export default class PriceFormatter {
	#options;

	constructor(
		currency_format_num_decimals,
		currency_format_symbol,
		currency_format_decimal_sep,
		currency_format_thousand_sep,
		currency_format
	) {
		this.#options = {
			symbol: currency_format_symbol,
			decimal: currency_format_decimal_sep,
			thousand: currency_format_thousand_sep,
			precision: currency_format_num_decimals,
			format: currency_format,
		};
	}

	format(value) {
		return accounting.formatMoney(value, this.#options);
	}
}
